import styled from 'styled-components';

const PageContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.surface || '#fff'};
  border-radius: 10px;
  padding: 1.25rem;
  border: 1px solid ${({ theme }) => theme.colors.border || '#e5e7eb'};

  @media (max-width: 768px) {
    padding: 0.625rem;
  }
`;

export default PageContainer;
